import { render } from "./AboutCommentary.vue?vue&type=template&id=56a411a6"
import script from "./AboutCommentary.vue?vue&type=script&lang=js"
export * from "./AboutCommentary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__